<template>
  <v-container fluid grid-list-lg pa-0 ma-0>
    <v-tabs centered show-arrows icons-and-text height='12em' color="white" v-model="selectedTab" @change="selectTeam(selectedTab)">
      <v-tab v-for='team in teams' :key='team.name'>
        <v-card-title class="subtitle-2">{{team.title}}</v-card-title>
        <v-img contain width="8em" height="8em" :src='team.logo'></v-img>
      </v-tab>
    </v-tabs>   
    <twitch-team-list :team='selectedTeam' v-if='selectedTeam' @errorUpdate="errorUpdate" />
  </v-container>
</template>
<script>
import TwitchTeamList from '@/components/TwitchTeamList'

export default {
  name: 'teams',
  components: {
    TwitchTeamList
  },
  mounted: function() {
    // Redirect from legacy
    if(this.$router.currentRoute.query.team) {
      this.$router.push("teams/" + this.$router.currentRoute.query.team)
      location.reload()
    }
  },
  methods: {
    selectTeam: function(i) {
      let name = this.teams[i].name
      this.selectedTeam = name;
      this.selectedTab = this.selectedTab
      this.$router.push({params: {team: name}})
    },
    errorUpdate: function(e) {
      this.$emit('errorUpdate', e)
    },
    teamIndex: function(currentValue){
      return currentValue.name == this.$router.currentRoute.params.team
    },
    setSelectedTab: function(){
      if(this.$router.currentRoute.params.team){
        this.selectedTab = this.teams.findIndex(this.teamIndex)
      }
    }
  },
  computed: {
    selectedTeamData () {
      return this.teams.filter(t => t.name == this.selectedTeam)[0]
    }
  },
  created () {
    this.setSelectedTab()
  },
  data() {
    return {
      isLoaded: false,
      error: null,
      selectedTeam: this.$router.currentRoute.params.team,
      selectedTab: -1,
      teams: [ { "name": "athletico", "title": "Athletico", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-athletico-team_logo_image-cfa4ab564272fea1-600x600.png" }, { "name": "corvidaeinc", "title": "Corvidae", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-corvidaeinc-team_logo_image-e450a5bffb50424e9d4a3dd8213145ec-600x600.jpeg" }, { "name": "jam", "title": "Just a Minute Gaming", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-jam-team_logo_image-2a8ede57732742bc91630c0eafdf26eb-600x600.jpeg" }, { "name": "mindfreak", "title": "Mindfreak", "logo": "https://pbs.twimg.com/profile_images/1009376025640177665/YTnsZWqA_400x400.jpg" }, { "name": "nzstreams", "title": "NZ Streams", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-nzstreams-team_logo_image-69e0241e9261405b98c9fffcd49ecf78-600x600.png" }, { "name": "respawnninja", "title": "Respawn Ninja", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-respawnninja-team_logo_image-465a53269cd9f17e-600x600.png" }, { "name": "shadecrew", "title": "shadecrew", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-shadecrew-team_logo_image-b77b05891fdf463586a1535f82c9692e-600x600.png" }, { "name": "shaggynation", "title": "Shaggy Nation", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-shaggynation-team_logo_image-43dce331677c4c56bf763e965a074eef-600x600.jpeg" }, { "name": "teamoce", "title": "Team OCE", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-teamoce-team_logo_image-e0a3f63ec7e3424a96e6a2dd6bdd3de3-600x600.png" }, { "name": "womanz", "title": "WomANZ", "logo": "https://static-cdn.jtvnw.net/jtv_user_pictures/team-womanz-team_logo_image-9822baee9d164eaf93a6cd03c58339f8-600x600.jpeg" } ],
    }
  }
}
</script>
<style>

</style>